module.exports = __webpack_public_path__ + "1.5.0-unryo/img/offline-portal-5.86f8f028.svg";